export default productId => {
	if (!window.productPageUrl) return '#';

	const url = window.productPageUrl;
	return `${url.endsWith('/') ? url.substring(-1) : url}?id=${productId}`;
}



// WEBPACK FOOTER //
// ../source/common/utils/create-product-url.js